import React from 'react'

const MobileNavOpen = React.createContext({
  mobileNavOpen: false,
  toggleMobileNavOpen: () => {},
})
MobileNavOpen.displayName = 'MobileNavOpen'

export {MobileNavOpen}
